import getSocket from '@/globals/socketConfig';

import anticipateDetail from './anticipateRender/detail';
import getCurrentIds from './getCurrentIds';

const openDetail = (e: any, doc_id: string, type = 'document') =>
{
	e.stopPropagation();

	const socket = getSocket();

	anticipateDetail();

	const { tab_id, session_id } = getCurrentIds();

	console.log('Opening detail with ID: ', doc_id, type);
	socket.emit('take_action', {
		action_type: type + '_detail',
		id: doc_id,
		session_id,
		tab_id
	});
};

export default openDetail;
